export const checkIsSetupComplete = (userAccount: any): boolean => {
  if (!userAccount) return false;
  return Boolean(userAccount.hygienist && Number(userAccount.hygienist.isComplete) === 1)
    || Boolean(userAccount.dentist && Number(userAccount.dentist.isComplete) === 1
      && Array.isArray(userAccount.locations) && userAccount.locations.length > 0);
};
